import { render } from "./BasicInfoForm.vue?vue&type=template&id=fd95ced8"
import script from "./BasicInfoForm.vue?vue&type=script&lang=js"
export * from "./BasicInfoForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__